<div *ngIf="show" class="c-loading w-full h-full">
  <div class="w-full h-full bg-gray-200 opacity-30"></div>
  <mat-card class="absolute c-loading__middle">
    <mat-spinner></mat-spinner>
  </mat-card>
</div>
